export default __webpack_public_path__ + "media/images/logo/media/logme-biz-08189b323e695873bcf83203b08feff1.png";